// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//dev server
export const environment = {
  production: true,
  api: 'https://podcast-backend.softobiz.net/v1/api/',
  testConferenceId: 'f5a28c9e-5bd5-4c7e-b3be-b992f432e091'
};

/*
 * For easier debugging in development mode, you can import the following file  
 * to ignore   zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
